import type { TicketStatus } from './api';

const LABELS: Record<TicketStatus, string> = {
  OPEN: 'Open',
  ACKNOWLEDGED: 'Acknowledged',
  IN_PROGRESS: 'In Progress',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
};

export default function StatusBadge({ status }: { status: TicketStatus }) {
  return <span className={`ticket-badge status-${status}`}>{LABELS[status] || status}</span>;
}
